import { render, staticRenderFns } from "./VideoGrid.vue?vue&type=template&id=36a089f3&"
import script from "./VideoGrid.vue?vue&type=script&lang=js&"
export * from "./VideoGrid.vue?vue&type=script&lang=js&"
import style0 from "./VideoGrid.vue?vue&type=style&index=0&id=36a089f3&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CmsEmbed: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/cms/CmsEmbed.vue').default})
